// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ScanEffortLevelSchema = z.enum(['HIGH','EXTRA_HIGH','EXTREME'] as const);

export type ScanEffortLevelType = `${z.infer<typeof ScanEffortLevelSchema>}`

export default ScanEffortLevelSchema;
